import Modal from './Modal';
import ModalUtils from './ModalUtils';
import IFormModalConfig from './IFormModalConfig';

class FormModal extends Modal {
  isSubmitting = false;

  isFormDisabled = false;

  disableFormDuringSubmit: boolean;

  callbacks: { onSubmit: () => Promise<void>; onCancel: () => void; };

  $form: HTMLFormElement;

  $btnSubmit: JQuery<HTMLButtonElement>;

  $btnCancel: JQuery<HTMLButtonElement> | undefined;

  disabledElements: JQuery<HTMLElement>[] | undefined;

  constructor(config_: Partial<IFormModalConfig>) {
    const config = {
      ...Modal.defaults,
      ...{
        labelBtnSubmit: 'Submit',
        labelBtnCancel: 'Cancel',
        disableFormDuringSubmit: true,
        onSubmit: async () => { },
        onCancel: () => { },
      },
      ...config_,
    };

    const { $form, labelBtnSubmit, labelBtnCancel } = config;

    const formId = $form?.id;

    if (!$form || !formId) {
      throw new Error('Given form element must have an id');
    }

    const $btnSubmit = ModalUtils.makePrimaryButton(labelBtnSubmit);
    $btnSubmit.attr('type', 'submit');
    $btnSubmit.attr('form', formId);

    let $btnCancel: JQuery<HTMLButtonElement> | undefined;

    if (labelBtnCancel) {
      $btnCancel = ModalUtils.makeSecondaryButton(labelBtnCancel);
    }

    const footerContents = [
      $btnSubmit,
    ];

    if ($btnCancel?.length) {
      footerContents.push($btnCancel);
    }

    config.bodyContents = $form;
    config.footerContents = footerContents;

    super(config);

    $btnSubmit.on('click', this.onSubmit);

    $form.addEventListener('submit', this.onSubmit);

    $btnCancel?.on('click', this.onBtnCancel);

    this.$form = $form;
    this.$btnSubmit = $btnSubmit;
    this.$btnCancel = $btnCancel;
    this.disableFormDuringSubmit = config.disableFormDuringSubmit;
    this.callbacks = {
      onSubmit: config.onSubmit,
      onCancel: config.onCancel,
    };
  }

  onSubmit = async (event: Event) => {
    event.preventDefault();

    if (this.isSubmitting) {
      return;
    }

    this.isSubmitting = true;

    if (this.disableFormDuringSubmit) {
      this.disableForm();
    }

    await this.callbacks.onSubmit();

    this.isSubmitting = false;
  };

  disableForm() {
    if (this.isFormDisabled) {
      return;
    }

    this.isFormDisabled = true;

    const disabledElements = [
      this.$el.find('fieldset').filter((_index, $el) => !$el.disabled),
      this.$el.find('button.close[data-dismiss="modal"]'),
    ];

    if (this.$btnCancel) {
      disabledElements.push(this.$btnCancel);
    }

    disabledElements.forEach(($el) => $el.prop('disabled', true));

    this.disabledElements = disabledElements;
  }

  enableForm() {
    if (!this.isFormDisabled) {
      return;
    }

    this.isFormDisabled = false;

    this.disabledElements?.forEach(($el) => $el.prop('disabled', false));

    this.disabledElements = undefined;
  }

  dismiss() {
    if (this.isSubmitting) {
      return;
    }

    this.callbacks.onCancel();

    super.dismiss();
  }

  onBtnCancel = () => {
    this.dismiss();
  };

  close() {
    if (this.isSubmitting) {
      return;
    }

    this.$btnSubmit.off();

    if (this.$btnCancel) {
      this.$btnCancel.off();
    }

    this.$form.removeEventListener('submit', this.onSubmit);

    if (this.disableFormDuringSubmit) {
      this.enableForm();
    }

    super.close();
  }
}

export default FormModal;
